import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';
import { ThemedNoDataIcon } from "assets/CXFIcons/Portal/Dashboard";

const NoDataIcon = ({ message, styles, variant }) => {
    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <ThemedNoDataIcon style={{ ...styles, marginBottom: "16px" }} />
            <Typography variant={variant || "h6"}>{message}</Typography>
        </Box>
    )
}

export default NoDataIcon;